import React from 'react';

import {
  BaseWidget,
  LabelledText
} from 'modules';

import { Grid } from '@mui/material';
import * as dataService from './dataService';



export interface IProps {
  returnAuthorizationId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.returnAuthorizationId);

  return (
    <BaseWidget.FC title="Triage Decision">
      <Grid container>
        <Grid
          item
          xs={6}>
          <LabelledText.FC
            title="Selected Workflow"
            text={queryTuple.data.triageDecision?.workflowName ?? '-'} />

          <LabelledText.FC
            title="Decision Date"
            text={queryTuple.data.triageDecision?.createdAt.toFormat('MM/dd/yy') ?? '-'} />

          <LabelledText.FC
            title="Technician"
            text={queryTuple.data.triageDecision?.technicianFullName ?? '-'} />
        </Grid>

        <Grid
          item
          xs={6}>
          <LabelledText.FC
            title="Repair Code"
            text={queryTuple.data.triageDecision?.repairCode ?? '-'} />

          <LabelledText.FC
            title="Outbound IMEI"
            text={queryTuple.data.triageDecision?.outboundImei ?? '-'} />

          <LabelledText.FC
            title="Technician Comment"
            text={queryTuple.data.triageDecision?.technicianComment ?? '-'} />
        </Grid>
      </Grid>
    </BaseWidget.FC>
  );
};
